import { GameDayModel } from '../../models/gameday-model';
import { GameDayViewType } from '../../state/data/state';
import {
  flattenBeforeAfter,
  getSegments,
  OrdersSegment
} from './gameDay-data.segmentations';
import {
  getGroupExtractor,
  segmentsExtractors,
  trancheExtractors
} from '../mappers/gameDay.extractors';
import {
  ordersSegmentsToTrancheGroups,
  TrancheGroup
} from './gameDay-data.transformations';

const FLATTEN_LEVEL = 2;

export function calculateSegments(
  data: GameDayModel.RawData,
  viewType: GameDayViewType
): OrdersSegment<any>[] {
  if (!data.deal || !data.orders || viewType === undefined) {
    return undefined;
  }
  return flattenBeforeAfter(
    getSegments(
      data.orders,
      data.deal.maturities,
      segmentsExtractors,
      getGroupExtractor(data, viewType)
    ),
    FLATTEN_LEVEL
  );
}

export function mapToObject(map: Map<any, any>): Record<string, unknown> {
  const obj = {};
  map.forEach((v, k) => (obj[k] = v));
  return obj;
}

export function objectToMap(object: Record<string, unknown>): Map<any, any> {
  const map = new Map<any, any>();
  Object.keys(object).forEach((k) => map.set(k, object[k]));
  return map;
}

export function getViewTypeValues(): any[] {
  return Object.keys(GameDayViewType);
}

export function setAllSegments(
  data: GameDayModel.RawData,
  map: Map<GameDayViewType, OrdersSegment<any>[]>,
  existing: GameDayViewType
): void {
  getViewTypeValues()
    .filter((viewType) => viewType !== existing)
    .forEach((viewType: GameDayViewType) =>
      map.set(viewType, calculateSegments(data, viewType))
    );
}

export function setAllTrancheGroups(
  segmentsMap: Map<GameDayViewType, OrdersSegment<any>[]>,
  map: Map<GameDayViewType, TrancheGroup[]>,
  existing: GameDayViewType
): void {
  getViewTypeValues()
    .filter((viewType) => viewType !== existing)
    .forEach((viewType: GameDayViewType) => {
      const segments: OrdersSegment<any>[] = segmentsMap.get(viewType);
      const trancheGroups: TrancheGroup[] = ordersSegmentsToTrancheGroups(
        segments,
        trancheExtractors
      );
      map.set(viewType, trancheGroups);
    });
}
